import { render } from "./SubmitDetails.vue?vue&type=template&id=d7e5d9a4&scoped=true&ts=true"
import script from "./SubmitDetails.vue?vue&type=script&lang=ts"
export * from "./SubmitDetails.vue?vue&type=script&lang=ts"

import "./SubmitDetails.vue?vue&type=style&index=0&id=d7e5d9a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e5d9a4"]])

export default __exports__